import React, { useEffect, useState } from 'react';
import {
  Modal,
  View,
  Text,
  TouchableOpacity,
  StyleSheet,
  Animated,
  Easing,
  useWindowDimensions,
  Pressable
} from 'react-native';
import LottieView from 'lottie-react-native';
import Icon from 'react-native-vector-icons/MaterialCommunityIcons';

const OrderCancellationModal = ({ visible, onClose, order }) => {
  const { width } = useWindowDimensions();
  // Extract orderCode and rejectionReason from the order object
  const orderCode = order?.orderCode || "Unknown";
  const rejectionReason = order?.rejectionReason || "Ismeretlen";
  const [fadeAnim] = useState(new Animated.Value(1));
  const [scaleAnim] = useState(new Animated.Value(1));

  // Animation for fading in/out and pulsing effect
  useEffect(() => {
    if (visible) {
      // Create a loop animation that combines fade and scale effects
      Animated.loop(
        Animated.parallel([
          // Fade animation (opacity between 0.8 and 1.0)
          Animated.sequence([
            Animated.timing(fadeAnim, {
              toValue: 0.8,
              duration: 800,
              easing: Easing.inOut(Easing.ease),
              useNativeDriver: true,
            }),
            Animated.timing(fadeAnim, {
              toValue: 1,
              duration: 800,
              easing: Easing.inOut(Easing.ease),
              useNativeDriver: true,
            }),
          ]),
          // Scale animation (size between 1.0 and 1.05)
          Animated.sequence([
            Animated.timing(scaleAnim, {
              toValue: 1.05,
              duration: 800,
              easing: Easing.inOut(Easing.ease),
              useNativeDriver: true,
            }),
            Animated.timing(scaleAnim, {
              toValue: 1,
              duration: 800,
              easing: Easing.inOut(Easing.ease),
              useNativeDriver: true,
            }),
          ]),
        ])
      ).start();
    } else {
      // Stop animations when modal is hidden
      fadeAnim.stopAnimation();
      scaleAnim.stopAnimation();
    }
  }, [visible, fadeAnim, scaleAnim]);

  if (!visible) return null;

  return (
    <Modal
      transparent
      visible={visible}
      animationType="fade"
      onRequestClose={onClose}
    >
      <Pressable style={styles.modalOverlay} onPress={onClose}>
        <Animated.View 
          style={[
            styles.modalContainer,
            { 
              width: Math.min(width * 0.8, 500),
              opacity: fadeAnim,
              transform: [{ scale: scaleAnim }]
            }
          ]}
        >
          <TouchableOpacity style={styles.closeButton} onPress={onClose}>
            <Icon name="close-circle" size={40} color="#333" />
          </TouchableOpacity>

          <View style={styles.contentContainer}>
            <LottieView
              source={require('../../assets/animations/Animation - 1749320837505.json')}
              autoPlay
              loop
              style={styles.lottieAnimation}
            />

            <Text style={styles.notificationText}>
              #{orderCode} számú rendelést törölték!
            </Text>

            <Text style={styles.reasonText}>
              A törlés oka: {rejectionReason}
            </Text>

            <TouchableOpacity 
              style={styles.actionButton}
              onPress={onClose}
            >
              <Text style={styles.actionButtonText}>
                Rendben
              </Text>
            </TouchableOpacity>
          </View>
        </Animated.View>
      </Pressable>
    </Modal>
  );
};

const styles = StyleSheet.create({
  modalOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContainer: {
    backgroundColor: 'white',
    borderRadius: 20,
    padding: 20,
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 10,
    },
    shadowOpacity: 0.5,
    shadowRadius: 15,
    elevation: 15,
    position: 'relative',
  },
  closeButton: {
    position: 'absolute',
    top: 10,
    right: 10,
    zIndex: 10,
  },
  contentContainer: {
    width: '100%',
    alignItems: 'center',
    paddingTop: 20,
  },
  lottieAnimation: {
    width: 200,
    height: 200,
  },
  notificationText: {
    fontSize: 22,
    fontWeight: 'bold',
    textAlign: 'center',
    marginTop: 20,
    color: '#333',
  },
  reasonText: {
    fontSize: 18,
    textAlign: 'center',
    marginVertical: 15,
    color: '#555',
  },
  actionButton: {
    backgroundColor: '#F44336', // Red color for cancellation
    paddingVertical: 15,
    paddingHorizontal: 20,
    borderRadius: 10,
    width: '100%',
    alignItems: 'center',
    marginTop: 10,
  },
  actionButtonText: {
    color: 'white',
    fontSize: 18,
    fontWeight: 'bold',
  },
});

export default OrderCancellationModal;
